import React from "react";
import { siteInfo } from "../mock";

const terms = [
  {
    title: "SMS Messaging Service",
    content: (
      <>
        By providing your phone number, you consent to receive SMS text messages
        from Galleria Dental for appointment reminders, marketing messages, and
        general two-way communication. Message frequency varies. Message and
        data rates may apply. Reply HELP for support or STOP to opt out.
      </>
    ),
  },
  {
    title: "Message Frequency",
    content:
      "Message frequency varies based on your interactions with our practice.",
  },
  {
    title: "Message and Data Rates",
    content:
      "Message and data rates may apply based on your mobile carrier's terms.",
  },
  {
    title: "Privacy Policy",
    content: (
      <>
        Your information will be handled in accordance with the Privacy Policy
        below.
      </>
    ),
  },
  {
    title: "Opt-Out Instructions",
    content: (
      <>
        You can opt out at any time by replying STOP to any SMS message. Reply
        HELP for support. You may also contact us at{" "}
        <a
          href={`mailto:${siteInfo.email}`}
          className="text-[#7D6A42] underline underline-offset-4 hover:text-[#5F4F30]"
        >
          {siteInfo.email}
        </a>{" "}
        or <a href={`tel:${siteInfo.phoneRaw}`} className="text-[#7D6A42] underline underline-offset-4 hover:text-[#5F4F30]">{siteInfo.phoneFormatted}</a>.
      </>
    ),
  },
  {
    title: "Liability",
    content:
      "We are not responsible for any charges, errors, or delays in SMS delivery caused by your carrier or third-party service providers.",
  },
];

const privacySections = [
  {
    title: "Information We Collect",
    content:
      "When you opt in to receive SMS messages, we collect your phone number and your consent to send SMS messages.",
  },
  {
    title: "How We Use Your Information",
    content:
      "We use your information to send you the SMS messages you have opted in to receive and to provide updates, promotions, or other relevant content based on your preferences.",
  },
  {
    title: "Sharing Your Information",
    content:
      "We do not share your phone number or SMS opt-in information with third parties for marketing purposes.",
  },
  {
    title: "Your Rights",
    content:
      "You can opt out of receiving SMS messages at any time by replying STOP to any message we send you.",
  },
  {
    title: "Data Security",
    content:
      "We implement reasonable measures to protect your personal information from unauthorized access or disclosure.",
  },
];

const TermsAndConditions = () => (
  <main className="bg-[#FBF8F1] text-[#4E5750]">
    <section className="border-b border-[#B79A68]/30 px-6 py-14 md:py-20">
      <div className="mx-auto max-w-4xl">
        <p className="font-cinzel text-xs uppercase tracking-[0.2em] text-[#7D6A42]">
          Galleria Dental 
        </p>
        <h1 className="mt-3 font-cinzel text-3xl uppercase leading-tight text-[#5F4F30] md:text-5xl">
          Terms and Conditions
        </h1>
        <p className="mt-5 text-sm text-[#4E5750]/75">
          Effective Date: October 20, 2026
        </p>
        <p className="mt-7 max-w-3xl leading-relaxed">
          By opting in to receive SMS messages from Galleria Dental 
          ("we," "us," or "our"), you agree to the following terms:
        </p>
      </div>
    </section>

    <section className="px-6 py-12 md:py-16">
      <div className="mx-auto max-w-4xl divide-y divide-[#B79A68]/25">
        {terms.map(({ title, content }, index) => (
          <section key={title} className="py-7 first:pt-0">
            <h2 className="font-cinzel text-base uppercase tracking-[0.08em] text-[#7D6A42]">
              {index + 1} - {title}
            </h2>
            <p className="mt-3 leading-7 text-[#4E5750]/90">{content}</p>
          </section>
        ))}
        <p className="py-7 leading-7 text-[#4E5750]/90">
          By opting in, you confirm that you are the owner or authorized user of
          the phone number provided and that you are at least 18 years old.
        </p>

        <section className="py-7">
          <h2 className="mt-3 font-cinzel text-3xl uppercase leading-tight text-[#5F4F30] md:text-5xl">
            Privacy Policy
          </h2>
          <p className="mt-5 text-sm text-[#4E5750]/75">
            Effective Date: October 20, 2026
          </p>
          <p className="mt-7 max-w-3xl leading-relaxed text-[#4E5750]/90">
            Galleria Dental ("we," "us," or "our") respects your privacy and
            is committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, and share information when you
            opt in to receive SMS messages from us.
          </p>
        </section>

        {privacySections.map(({ title, content }) => (
          <section key={title} className="py-7">
            <h3 className="font-cinzel text-base uppercase tracking-[0.08em] text-[#7D6A42]">
              {title}
            </h3>
            <p className="mt-3 leading-7 text-[#4E5750]/90">{content}</p>
          </section>
        ))}

        <section className="py-7">
          <h3 className="font-cinzel text-base uppercase tracking-[0.08em] text-[#7D6A42]">
            Contact Us
          </h3>
          <p className="mt-3 leading-7 text-[#4E5750]/90">
            If you have questions or concerns about our privacy practices,
            contact us at{" "}
            <a
              href={`mailto:${siteInfo.email}`}
              className="text-[#7D6A42] underline underline-offset-4 hover:text-[#5F4F30]"
            >
              {siteInfo.email}
            </a>
            .
          </p>
        </section>
      </div>
    </section>
  </main>
);

export default TermsAndConditions;